import BreedsFragment from '../cms/BreedsFragment';
import { MediaFragment } from '../media/MediaFragment';
export default `
  fragment PetProfileFragment on PetProfile {
    id
    name
    age
    ageContext
    dob
    weight
    birthYear
    alterationStatus
    gender
    temperment
    activityLevel
    bodyCondition
    eatingBehavior
    currentMealType
    currentMealSize
    currentMealTypeBrand
    treats
    scraps
    foodAllergies
    media
    breed {
      ...BreedsFragment
    }
    image {
      ...MediaFragment
    }
    status
    createdAt
    updatedAt
  }
  ${BreedsFragment}
  ${MediaFragment}
`;
